import type { ContractorTranslation } from './en';

export const ko: ContractorTranslation = {
  common: {
    cancel: '취소',
    save: '저장',
    retry: '다시 시도',
    download: '다운로드',
    continue: '계속',
    yes: '예',
    no: '아니요',
    genericError: '문제가 발생했습니다. 다시 시도해 주세요.',
    networkError: 'DubForge에 연결할 수 없습니다. 인터넷 연결을 확인해 주세요.',
  },
  app: {
    tagline: '더빙 작업, 파일, 검토를 한곳에서.',
    startupFailed: 'DubForge를 시작할 수 없습니다',
    notFoundTitle: '페이지를 찾을 수 없습니다',
    notFoundBody: '페이지가 존재하지 않거나 접근 권한이 없습니다.',
    goHome: '홈으로 이동',
    crashTitle: '문제가 발생했습니다',
    crashBody: '페이지를 새로고침해 보세요.',
    reload: '새로고침',
  },
  language: {
    label: '언어',
    change: '언어 변경',
  },
  welcome: {
    title: 'DubForge에 오신 것을 환영합니다',
    body: '사용할 언어를 선택하세요. DubForge와 Discord 알림에 이 언어가 사용됩니다.',
    changeLater: '오른쪽 위의 언어 메뉴에서 언제든지 변경할 수 있습니다.',
  },
  nav: {
    myAssignments: '내 작업',
    openMenu: '메뉴 열기',
    account: '계정',
    notificationEmail: '알림 이메일',
    signOut: '로그아웃',
    roleAdmin: '관리자',
    roleContractor: '성우',
    lightMode: '라이트 모드',
    darkMode: '다크 모드',
  },
  login: {
    signIn: 'Discord로 로그인',
    onlyInvited: '채널 소유자가 추가한 Discord 계정만 로그인할 수 있습니다.',
    signingIn: '로그인하는 중…',
    backToSignIn: '로그인 화면으로 돌아가기',
    failed: '로그인하지 못했습니다. 다시 시도해 주세요.',
  },
  authErrors: {
    not_invited: '이 Discord 계정은 DubForge에 추가되지 않았습니다. 채널 소유자에게 추가를 요청하세요.',
    access_off: 'DubForge 접근 권한이 해제되었습니다.',
    discord_only: 'Discord로만 로그인할 수 있습니다.',
  },
  errors: {
    not_signed_in: '세션이 만료되었습니다. 다시 로그인해 주세요.',
    access_off: 'DubForge 접근 권한이 해제되었습니다.',
    admins_only: '이 작업을 할 권한이 없습니다.',
    not_found: '항목이 존재하지 않거나 더 이상 사용할 수 없습니다.',
    invalid_request: '요청 내용이 올바르지 않습니다. 확인 후 다시 시도해 주세요.',
    conflict: '이미 존재합니다.',
    already_approved: '이 작업은 이미 승인되어 더 이상 업로드할 필요가 없습니다.',
    not_audio: 'WAV 또는 MP3 파일만 업로드할 수 있습니다. 본인 음성 트랙만 업로드해 주세요.',
    upload_incomplete: '업로드가 완료되지 않았습니다. 다시 시도해 주세요.',
    discord_unreachable: 'Discord에 연결할 수 없습니다. 잠시 후 다시 시도해 주세요.',
    server_error: '서버에서 문제가 발생했습니다. 다시 시도해 주세요.',
  },
  notifications: {
    title: '알림',
    openWithCount: '알림 (읽지 않음 {{count}}개)',
    markAllRead: '모두 읽음으로 표시',
    empty: '아직 알림이 없습니다.',
  },
  emailSettings: {
    body: '새 작업이 배정되거나 작업 검토가 끝나면 이메일로 알려 드립니다.',
    label: '이메일 주소',
    fromDiscord: 'Discord 계정의 이메일입니다. 다른 주소를 원하면 변경하세요.',
    saved: '이메일 주소를 저장했습니다',
    invalid: '올바른 이메일 주소를 입력하세요.',
    missing: '아직 이메일 주소가 없습니다. 알림을 받으려면 추가하세요.',
  },
  status: {
    Assigned: '배정됨',
    InProgress: '진행 중',
    Submitted: '검토 대기 중',
    ChangesRequested: '수정 요청됨',
    Approved: '승인됨',
  },
  assetKind: {
    package: '더빙 패키지 (영상 + 음성 + SFX)',
    video: '참고 영상 (720p)',
    sfx: 'SFX / 음악 트랙',
    voice: '원본 음성 트랙',
    script: '대본',
    other: '기타',
  },
  translation: {
    machine: '기계 번역',
    showOriginal: '원문 보기',
    showTranslation: '번역 보기',
  },
  uploader: {
    progress: '{{size}} 중 {{percent}}%',
    queued: '업로드 대기: {{count}}개',
    keepOpen: '완료될 때까지 이 탭을 열어 두세요.',
    cancelled: '업로드가 취소되었습니다',
    done: '{{name}} 업로드 완료',
    failed: '업로드 실패: {{error}}',
  },
  my: {
    greeting: '안녕하세요, {{name}} 님',
    subtitle: '내 더빙 작업입니다.',
    emptyTitle: '아직 작업이 없습니다',
    emptyBody: '영상이 배정되면 Discord 메시지가 오고 여기에 표시됩니다.',
    todo: '할 일',
    waiting: '검토 대기 중',
    done: '완료',
    updated: '{{when}} 업데이트됨',
  },
  assignment: {
    back: '내 작업',
    dubIn: '더빙: {{language}}',
    paid: '지급 완료',
    next: {
      Assigned: '소스 파일을 다운로드하고 목소리를 녹음한 다음, 여기에 음성 트랙을 업로드하세요.',
      InProgress: '음성 트랙이 준비되면 아래에서 업로드하세요.',
      Submitted: '더빙이 검토를 위해 제출되었습니다. 검토가 끝나면 Discord 메시지로 알려 드립니다.',
      ChangesRequested: '수정 요청이 있습니다. 아래 피드백을 확인한 후 새 버전을 업로드하세요.',
      Approved: '승인되었습니다. 감사합니다!',
    },
    notes: '메모',
    sourceFiles: '소스 파일',
    noFiles: '아직 업로드된 파일이 없습니다.',
    fileInfo: '{{kind}} · {{size}}',
    packageHint: '영상과 오디오 트랙 2개가 들어 있는 .mp4 파일 하나입니다. 트랙 1은 원본 대사, 트랙 2는 SFX입니다.',
    uploadTitle: '음성 트랙 업로드',
    voiceOnlyTitle: '본인 목소리만',
    voiceOnlyBody: '녹음한 본인 목소리만 업로드하세요. 음악, 효과음, 원본 오디오는 포함하지 마세요. 길이는 원본과 같아야 합니다.',
    voiceOnlyConfirm: '이 파일에는 대사 음성만 들어 있습니다.',
    dropLabel: '여기에 음성 트랙을 업로드하세요',
    dropHint: 'WAV 또는 MP3만 가능합니다.',
    noteForReviewer: '검토자에게 남길 메모 (선택 사항)',
    lengthTitle: '길이가 맞지 않습니다',
    lengthBody:
      '파일 길이는 {{dub}}, SFX 트랙 길이는 {{sfx}}입니다. 시작 지점이 다르거나 중간에 잘려 있으면 영상과 싱크가 맞지 않습니다. 그래도 업로드할까요?',
    uploadAnyway: '그래도 업로드',
    chooseAnother: '다른 파일 선택',
    versions: '업로드한 버전',
    nothingUploaded: '아직 업로드한 것이 없습니다.',
    version: '버전 {{version}}',
    reviewApproved: '승인됨',
    reviewChanges: '수정 요청됨',
    reviewPending: '검토 대기 중',
    yourNote: '내 메모:',
    feedback: '피드백',
    listen: '듣기',
    uploadedOn: '{{date}} · {{size}}',
    length: '길이: {{duration}}',
  },
};
